import React, {useMemo} from 'react';
import {useForm, Controller} from "react-hook-form";
import PressPalletIcon from "../PressPalletIcon";
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import * as yup from "yup";
import {yupResolver} from '@hookform/resolvers';
import BaseAdHocPage from "../../../framework/util/uicomps/BaseAdHocPage";
import PalletEventsTable from './PalletEventsTable';
import NextBackButtonBar from "../../../framework/util/forms/NextBackButtonBar";

const validationStartBuilding = yup.object({});


const ManualPalletChooseJobs = ({currentState, sendEvent}) => {

    const {register, handleSubmit, errors} = useForm({
        resolver: yupResolver(validationStartBuilding)
    });

    const onSubmit = async data => {
        data.selectedJobs = getSelectedJobs();
        sendEvent("NEXT", data);
    };


    const context = currentState.context.chooseJobs;
    const pallets = context.pallets;
    const jobs = context.jobs;
    const press = context.station;
    const startDate = currentState.context.palletData.loadTime;
    const endDate = currentState.context.palletData.unloadTime;
    const hours = currentState.context.hours;

    const baseContentItems = [
        (<Grid item xs={12}>
                <PalletEventsTable pallets={pallets} jobs={jobs} press={press} startDate={startDate} endDate={endDate}/>
            </Grid>
        ),
    ];

    const getSelectedJobs = ()=> {
        const sel = [];
        jobs.forEach(job=>job.selected && sel.push(job));
        return sel;
    }

    const buttonItems = [];

    const buttonBar = (<NextBackButtonBar onBack={()=>sendEvent("BACK")} nextButtonType={'submit'} />);
    buttonItems.push(buttonBar);

    const form = (
        <form onSubmit={handleSubmit(onSubmit)}>
            <BaseAdHocPage icon={<PressPalletIcon/>} title={'Choose Jobs For Manifest - Last ' + hours + ' hours '} width={'100%'}
                           description={'Select jobs to add.  Rows are highlighted between pallet load and unload times'} buttons={buttonItems}
                           content={baseContentItems}/>
        </form>
    );

    return form;
}

export default ManualPalletChooseJobs;
